import React from 'react'
import { Game } from '../srm/srm-parser'

type ResourceKey = 'energy' | 'reserve' | 'missiles' | 'superMissiles' | 'powerBombs'

const RESOURCE_ROWS: [string, ResourceKey][] = [
  ['Energy', 'energy'],
  ['Reserve', 'reserve'],
  ['Missiles', 'missiles'],
  ['Super Missiles', 'superMissiles'],
  ['Power Bombs', 'powerBombs']
]

function ResourcesSection({
  resources,
  onUpdate
}: {
  resources: Game['resources']
  onUpdate: (resource: ResourceKey, field: 'current' | 'max', value: number) => void
}) {
  return (
    <div className="card-section">
      <h3 className="section-title">Resources</h3>
      <div className="resource-grid">
        <span />
        <span className="resource-col-header">Current</span>
        <span className="resource-col-header">Max</span>
        {RESOURCE_ROWS.map(([label, key]) => (
          <React.Fragment key={key}>
            <span className="resource-label">{label}</span>
            <input
              className="num-input"
              type="number"
              min={0}
              value={resources[key].current.dec}
              onChange={(e) =>
                onUpdate(key, 'current', Math.max(0, parseInt(e.target.value) || 0))
              }
            />
            <input
              className="num-input"
              type="number"
              min={0}
              value={resources[key].max.dec}
              onChange={(e) =>
                onUpdate(key, 'max', Math.max(0, parseInt(e.target.value) || 0))
              }
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default ResourcesSection
